import React, { FC } from 'react'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import {
  GHeadingSM,
  GParagraphLG,
  GParagraphMD,
  GResponsiveText,
  GTitleLG,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import {
  getIwasPrizeText,
  getIwasIntroText,
  getIwasSecondPrizeText,
} from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-prizes/projects/iwas'

export const IwasDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  return (
    <div className="mt-3 grid gap-16">
      {getIwasIntroText(t)}
      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GHeadingSM}
        >
          {t('PrizesList', 'Prizes List')}
        </GResponsiveText>
        {getIwasPrizeText(t)}
        <Translate i18nKey={'EstimatedValueIwasV2'} t={t}>
          <GResponsiveText
            color="giveaway-text-subtle-light"
            className={'py-8 !font-bold'}
            MobileTextComponent={GParagraphMD}
            DesktopTextComponent={GParagraphLG}
          >
            Estimated value: $20,000
          </GResponsiveText>
        </Translate>
        {getIwasSecondPrizeText(t)}
      </div>
    </div>
  )
}
